// Dossier En Attente API

import { apiClient } from '@/core/api/client';
import type { 
  DossierEnAttenteApiResponse, 
  DossierEnAttenteStatsResponse 
} from '../types/dossier-en-attente.types';

export const dossierEnAttenteAPI = {
  /**
   * Get list of dossiers en attente (status 50-100)
   */
  async getDossierEnAttente(): Promise<DossierEnAttenteApiResponse> {
    try {
      const response = await apiClient.get<DossierEnAttenteApiResponse>('/api/expert/dossier-en-attente');
      return response;
    } catch (error) {
      console.error('Error fetching dossier en attente:', error);
      throw error;
    }
  },

  /**
   * Get statistics for dossier en attente dashboard
   */
  async getStats(): Promise<DossierEnAttenteStatsResponse> {
    try {
      const response = await apiClient.get<DossierEnAttenteStatsResponse>('/api/expert/stats');
      return response;
    } catch (error) {
      console.error('Error fetching expert stats:', error);
      throw error;
    }
  },

  /**
   * Mark a dossier as urgent
   */
  async markAsUrgent(expertiseId: number): Promise<{ success: boolean }> {
    try {
      const response = await apiClient.post<{ success: boolean }>(`/api/expert/expertise/${expertiseId}/urgent`);
      return response;
    } catch (error) {
      console.error('Error marking dossier as urgent:', error);
      throw error;
    }
  },

  /**
   * Update dossier status
   */
  async updateStatus(
    expertiseId: number,
    status: string
  ): Promise<{ success: boolean }> {
    try {
      const response = await apiClient.put<{ success: boolean }>(`/api/expert/expertise/${expertiseId}/status`, {
        status
      });
      return response;
    } catch (error) {
      console.error('Error updating dossier status:', error);
      throw error;
    }
  }
};